import "@angular/compiler";
import { enableProdMode, provideZoneChangeDetection } from "@angular/core";
import { platformBrowser } from "@angular/platform-browser";
import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";
import { loadTranslations } from "@angular/localize";
import { CstLanguageService } from "./app/services/cst-language.service";

if (environment.production) {
  enableProdMode();
}

export function getBaseUrl() {
  return document.getElementsByTagName("base")[0].href;
}

const providers = [
  { provide: "API_BASE_URL", useFactory: getBaseUrl, deps: [] },
];

async function loadTranslationFile(
  name: string,
): Promise<Record<string, string>> {
  try {
    const module = await import(`./locale/messages${name}.json`);
    return module.default ?? module;
  } catch {
    console.warn(
      `Translation file "messages${name}.json" not found, using defaults.`,
    );
    return {};
  }
}

async function prepareApp() {
  const locale = CstLanguageService.currentAppLanguageStatic();
  $localize.locale = locale;
  const localePrefix = locale === "en" ? "" : `.${locale}`;

  const translations = await loadTranslationFile(localePrefix);
  const branche = localStorage.getItem("current-branche") ?? "Elevator";

  const finalTranslations: Record<string, string> = { ...translations };
  if (branche && branche !== "Elevator") {
    const overrides = await loadTranslationFile(
      `${localePrefix}.${branche.toLowerCase()}`,
    );

    // Merge: keep all original translations, only override where radiator
    // provides a non-empty translation value
    for (const [key, value] of Object.entries(overrides)) {
      if (value !== undefined && value !== null && value !== "") {
        finalTranslations[key] = value;
      }
    }
  }

  loadTranslations(finalTranslations);

  return platformBrowser(providers).bootstrapModule(AppModule, {
    applicationProviders: [provideZoneChangeDetection()],
  });
}

prepareApp().catch(console.error);
